//@ts-check

/**
 * Get a promise that will be resolved with the current address; or rejected with an error reason
 * @param {import('./types').GoogleAPI} googleApi
 * @returns {Promise<string>}
 */
var getCurrentAddress = function getCurrentAddress(googleApi) {
  return new Promise(function (resolve, reject) {
    if (!googleApi) return reject('Invalid API Key!');
    if (!navigator || !navigator.geolocation) return reject('Cannot retrieve current location!');
    /**
     * @param {Position} position
     */

    var successCallback = function successCallback(position) {
      var coords = position.coords;
      /**@type {google.maps.GeocoderRequest} */

      var geocoderRequest = {
        location: new googleApi.maps.LatLng(coords.latitude, coords.longitude)
      };
      var geocoder = new googleApi.maps.Geocoder();
      geocoder.geocode(geocoderRequest, function (results, status) {
        if (status === googleApi.maps.GeocoderStatus.OK) resolve(results[0].formatted_address);else reject('Cannot found the location!');
      });
    };

    var errorCallback = function errorCallback(error) {
      reject(error);
    };

    navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
  });
};

export default getCurrentAddress;